export enum CAMERA_DIALOG_ACTIONS {
  Gallery = 'upload.attachment_source_gallery',
  Camera = 'upload.attachment_source_camera',
  File = 'upload.attachment_source_file',
}
